import Button, { ButtonType } from "@/components/reusable/Button";
import { usePathname } from "next/navigation";
import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  baseUrl: string;
}

export default function Pagination({
  currentPage,
  totalPages,
  baseUrl,
}: PaginationProps) {
  const pathname = usePathname();

  if (totalPages <= 1) return null; // No pagination needed if only one page

  return (
    <div className="flex justify-between items-center font-source-sans font-bold">
      <div className="flex gap-2 justify-center w-full">
        {Array.from({ length: totalPages }, (_, i) => i + 1)
          .filter((page) => {
            // Show first page, last page, current page, and pages around current
            return (
              page === 1 ||
              page === totalPages ||
              Math.abs(currentPage - page) <= 2
            );
          })
          .map((page, index, array) => (
            <React.Fragment key={page}>
              {index > 0 && array[index - 1] !== page - 1 && (
                <span className="text-neutral-400 px-1 self-center">...</span>
              )}
              <Button
                type={
                  (page === 1 && pathname === `${baseUrl}/`) ||
                  pathname ===
                    `${baseUrl}/${process.env.NEXT_PUBLIC_BLOG_PAGE_SLUG}/${page}/`
                    ? ButtonType.tertiary
                    : ButtonType.tertiaryOutline
                }
                link={
                  page === 1
                    ? baseUrl
                    : `${baseUrl}/${process.env.NEXT_PUBLIC_BLOG_PAGE_SLUG}/${page}`
                }
                className="w-fit p-5"
              >
                {page}
              </Button>
            </React.Fragment>
          ))}
      </div>
    </div>
  );
}
